module.exports = __webpack_public_path__ + "img/video_fill.3ed8c313.svg";